import { createContext } from 'react'

type ContextProps = { heading: string }

const defaultValue: ContextProps = { heading: '' } as const

const Context = createContext(defaultValue)

export { Context }
